import {Box} from '@mui/material';
import GeoJSON from 'ol/format/GeoJSON';
import {object} from 'prop-types';
import React from 'react';

import {MeasureIndicator} from '../measure-indicator.jsx';
import Overlay from '../overlay.jsx';

export const MeasureOverlay = ({geometry, mapRef}) => {
  const olGeom = new GeoJSON().readGeometry(geometry);
  const coordinate =
    olGeom.getType() === 'LineString'
      ? olGeom.getCoordinateAt(0.5)
      : olGeom.getInteriorPoint().getLastCoordinate();

  return (
    <Overlay coordinate={coordinate} map={mapRef}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Box
          sx={theme => ({
            display: 'inline-block',
            width: theme.spacing(0.5),
            height: theme.spacing(0.5),
            borderRight: `${theme.spacing(0.75)} solid ${theme.vars.palette.grey[400]}`,
            borderTop: `${theme.spacing(0.75)} solid transparent`,
            borderBottom: `${theme.spacing(0.75)} solid transparent`,
          })}
        />
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            borderRadius: 0.5,
            padding: 1,
            backgroundColor: 'grey.400',
          }}
        >
          <MeasureIndicator geometry={geometry} />
        </Box>
      </Box>
    </Overlay>
  );
};

MeasureOverlay.propTypes = {
  geometry: object.isRequired,
  mapRef: object.isRequired,
};
